/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Pessoa } from '../models/pessoa';
import { Congenere } from '../models/congenere';

/**
 * API para integracao com o servico corporativo de cadastro de congeneres
 */
@Injectable({
  providedIn: 'root',
})
class CongenereService extends __BaseService {
  static readonly obterListaPessoasPath = '/pessoas';
  static readonly obterCadastroCongeneresPath = '/congeneres';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Recupera a lista de pessoas
   * @param params The `CongenereService.ObterListaPessoasParams` containing the following parameters:
   *
   * - `per_page`:
   *
   * - `page`:
   *
   * - `numeroCpf`:
   *
   * - `numeroCnpj`:
   *
   * - `nomeLegalPessoa`:
   *
   * - `codigoTipoPessoa`:
   *
   * - `codigoTipoPapelPessoa`:
   *
   * @return Operacao realizada com sucesso
   */
  obterListaPessoasResponse(params: CongenereService.ObterListaPessoasParams): __Observable<__StrictHttpResponse<Array<Pessoa>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.perPage != null) __params = __params.set('per_page', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.numeroCpf != null) __params = __params.set('numeroCpf', params.numeroCpf.toString());
    if (params.numeroCnpj != null) __params = __params.set('numeroCnpj', params.numeroCnpj.toString());
    if (params.nomeLegalPessoa != null) __params = __params.set('nomeLegalPessoa', params.nomeLegalPessoa.toString());
    if (params.codigoTipoPessoa != null) __params = __params.set('codigoTipoPessoa', params.codigoTipoPessoa.toString());
    if (params.codigoTipoPapelPessoa != null) __params = __params.set('codigoTipoPapelPessoa', params.codigoTipoPapelPessoa.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/pessoas`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Pessoa>>;
      })
    );
  }
  /**
   * Recupera a lista de pessoas
   * @param params The `CongenereService.ObterListaPessoasParams` containing the following parameters:
   *
   * - `per_page`:
   *
   * - `page`:
   *
   * - `numeroCpf`:
   *
   * - `numeroCnpj`:
   *
   * - `nomeLegalPessoa`:
   *
   * - `codigoTipoPessoa`:
   *
   * - `codigoTipoPapelPessoa`:
   *
   * @return Operacao realizada com sucesso
   */
  obterListaPessoas(params: CongenereService.ObterListaPessoasParams): __Observable<Array<Pessoa>> {
    return this.obterListaPessoasResponse(params).pipe(
      __map(_r => _r.body as Array<Pessoa>)
    );
  }

  /**
   * Recupera a lista de Congeneres
   * @return Operacao realizada com sucesso
   */
  obterCadastroCongeneresResponse(): __Observable<__StrictHttpResponse<Array<Congenere>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/congeneres`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Congenere>>;
      })
    );
  }
  /**
   * Recupera a lista de Congeneres
   * @return Operacao realizada com sucesso
   */
  obterCadastroCongeneres(): __Observable<Array<Congenere>> {
    return this.obterCadastroCongeneresResponse().pipe(
      __map(_r => _r.body as Array<Congenere>)
    );
  }
}

module CongenereService {

  /**
   * Parameters for obterListaPessoas
   */
  export interface ObterListaPessoasParams {
    perPage?: number;
    page?: number;
    numeroCpf?: string;
    numeroCnpj?: string;
    nomeLegalPessoa?: string;
    codigoTipoPessoa?: number;
    codigoTipoPapelPessoa?: number;
  }
}

export { CongenereService }
